export const FLT_MAX = 1e+37;
export const DELTA_PER_STEP = 1e-5;
export const DELTA_MINIMUM = 1e-7;
export const T_MIN = -3;
export const T_MAX = 3;
export const paramsDimensions = ["x", "y"];
export const paramsOrder = ["xx", "yy", "tt", "xy", "xt", "yt", "x", "y", "t"];
